
const CollectionName = "user";
let unsubUser;

export async function sendLog(method, message) {
    console.log(`Error occured in method: ${method}. Sending log with message:`);
    console.error(message);
    let user = await db.getCurrentUser();
    if (!user) {
        console.log(`no user. can't send log`);
        return;
    }
    await db.addDocument(
        `${CollectionName}/${user.uid}/logs`,
        {
            ts: db.serverTimestamp(),
            message,
            method,
        })
}


export async function listenToUserDetails(authUser, cb) {
    if (!authUser) return Promise.reject("not logged in");

    if (unsubUser) {
        await db.removeListener(unsubUser)
    }
    unsubUser = await db.listenToDocument(CollectionName, authUser.uid, cb)
}

export async function getUserDetails(authUser, cb) {
    if (!authUser) return Promise.reject("not logged in");

    try {
        return await db.getDocument(CollectionName, authUser.uid)
    } catch (e) {
        await db.updateDocument(CollectionName, authUser.uid, {id: authUser.uid});
        return await db.getDocument(CollectionName, authUser.uid)
    }
}

export async function setFcmToken(userId, token, os) {
    return await db.updateDocument(CollectionName, userId, {
        fcmToken: token,
        os: os ?? 'Web',
        updatedAt: db.serverTimestamp(),
    });

    // return await firebase.firestore().collection(CollectionName).doc(userId).set(
    //     {
    //         fcmToken: token,
    //         updatedAt: db.serverTimestamp(),
    //     },
    //     { merge: true }
    // );
}
